export default function CustomerList(prop) {
  return (
    <>
      <p>{prop.text}</p>
    </>
  );
}
